import cls from "classnames";
import { jsx as _jsx } from "react/jsx-runtime";
function Spinner(_ref) {
  var bem = _ref.bem;
  return /*#__PURE__*/_jsx("div", {
    className: cls(bem("spinner")),
    children: Array(12).fill(null).map(function (_, index) {
      return /*#__PURE__*/_jsx("i", {
        className: cls(bem('spinner-line', String(index + 1)))
      }, index);
    })
  });
}
export default Spinner;